import { Div, state } from '@codesuma/baseline'
import settings from '../../../services/settings'
import style from './index.module.css'

// Segmented Jalaali ↔ Gregorian switch, centered in the home page's bottom bar.
// One pointer gesture handles everything: a tap picks the tapped half, a drag
// carries the thumb and snaps to the nearest side on release. The change goes
// through settings, so the slides re-render via the existing subscription.
// The pill is LTR inside so thumb math is direction-free: میلادی left,
// جلالی right (the reading-first side in RTL).
export const CalendarToggle = () => {
    const base = Div()
    base.addClass(style.base)
    base.attr('data-ripple', '')

    const thumb = Div()
    thumb.addClass(style.thumb)
    const gregorian = Div('میلادی')
    gregorian.addClass(style.option)
    const jalaali = Div('جلالی')
    jalaali.addClass(style.option)
    base.append(thumb, gregorian, jalaali)

    // Snap the thumb and label highlight to the persisted system
    const sync = () => {
        const jal = settings.get().system === 'jalaali'
        thumb.style({ transition: '', transform: jal ? 'translateX(100%)' : 'translateX(0)' })
        jalaali.toggleClass(style.active, jal)
        gregorian.toggleClass(style.active, !jal)
    }

    let pointerId: number | null = null
    let startX = 0
    let startPos = 0 // thumb offset at gesture start (0 = میلادی, travel = جلالی)
    let travel = 0 // one slot width in px
    let dragging = false

    const dragPos = (clientX: number) =>
        Math.min(travel, Math.max(0, startPos + (clientX - startX)))

    base.on('pointerdown', (e: PointerEvent) => {
        if (pointerId !== null) return
        pointerId = e.pointerId
        startX = e.clientX
        travel = thumb.el.offsetWidth
        startPos = settings.get().system === 'jalaali' ? travel : 0
        dragging = false
        base.el.setPointerCapture(e.pointerId)
    })

    base.on('pointermove', (e: PointerEvent) => {
        if (e.pointerId !== pointerId) return
        if (!dragging && Math.abs(e.clientX - startX) <= 4) return
        dragging = true
        thumb.style({ transition: 'none', transform: `translateX(${dragPos(e.clientX)}px)` })
    })

    base.on('pointerup', (e: PointerEvent) => {
        if (e.pointerId !== pointerId) return
        pointerId = null
        let jal: boolean
        if (dragging) {
            jal = dragPos(e.clientX) > travel / 2
        } else {
            // Tap: pick the tapped half (LTR: right half is جلالی)
            const { left, width } = base.el.getBoundingClientRect()
            jal = e.clientX - left > width / 2
        }
        const target = jal ? 'jalaali' : 'gregorian'
        if (settings.get().system !== target) settings.update({ system: target })
        else sync() // no change: just snap the thumb back
    })

    base.on('pointercancel', (e: PointerEvent) => {
        if (e.pointerId !== pointerId) return
        pointerId = null
        sync()
    })

    sync()
    state.on('settings', sync)
    base.on('unmounted', () => state.off('settings', sync))

    return base
}
